import { render } from "./APIVOD.vue?vue&type=template&id=64890f4e&scoped=true"
import script from "./APIVOD.vue?vue&type=script&lang=js"
export * from "./APIVOD.vue?vue&type=script&lang=js"

import "./APIVOD.vue?vue&type=style&index=0&id=64890f4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64890f4e"]])

export default __exports__